<template>
	<common-transition-slide :active="shouldShowReviewBar" :duration="250">
		<common-card class="omapi-review-bar">
			<div
				class="omapi-card-icon omapi-card-icon__close"
				@click.stop.prevent="instantDismiss()"
			>Dismiss</div>

			<div class="omapi-review-bar__title">Are you enjoying OptinMonster?</div>

			<div class="omapi-review-bar__buttons">
				<core-button
					color="blue"
					@click.stop.prevent="showNextStep(true)"
				>Yes 🙂</core-button>

				<core-button
					type="primary"
					@click.stop.prevent="showNextStep(false)"
				>Not Really!</core-button>
			</div>

			<div class="omapi-review-bar__step" v-if="showPositive">
				<p>That's awesome! Could you please do me a BIG favor and give it a 5-star rating on WordPress to help us spread the word and boost our motivation?</p>
				<p><strong>~ Thomas Griffin<br>Co-Founder of OptinMonster</strong></p>
				<div>
					<core-loading-button
						color="blue"
						target="_blank"
						:loading="isDismissing"
						rel="noopener noreferrer"
						:href="$urls.app('redirect/wp-plugin-review/')"
						@click="dismissReview(false)"
					>Ok, you deserve it</core-loading-button>

					<core-loading-button
						type="primary"
						:loading="isDismissing"
						@click.stop.prevent="dismissReview(true)"
					>Nope, maybe later!</core-loading-button>

					<core-loading-button
						is-link
						link-style
						:loading="isDismissing"
						@click.stop.prevent="dismissReview(false)"
					>I already did!</core-loading-button>
				</div>
			</div>

			<div class="omapi-review-bar__step" v-if="showNegative">
				<p>We're sorry to hear you aren't enjoying OptinMonster. We would love a chance to improve. Could you take a minute and let us know what we can do better?</p>
				<div>
					<core-loading-button
						color="blue"
						target="_blank"
						:loading="isDismissing"
						rel="noopener noreferrer"
						:href="$urls.utmLink($urls.marketing('plugin-review-feedback'), {
							utm_source: 'WordPress',
							utm_campaign: 'Plugin',
							utm_medium: 'ReviewNotice',
						})"
						@click="dismissReview(false)"
					>Give feedback</core-loading-button>

					<core-loading-button
						is-link
						link-style
						:loading="isDismissing"
						@click.stop.prevent="dismissReview(false)"
					>No thanks!</core-loading-button>
				</div>
			</div>
		</common-card>
	</common-transition-slide>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
	data : () => ({
		showPositive : false,
		showNegative : false,
		dismissed    : false,
	}),
	mounted () {
		if (this.showReview) {
			// dispatch to next tick to avoid race conditions
			this.$nextTick(() => {
				this.fetchAllRequired()
			})
		}
	},
	computed : {
		...mapGetters([ 'showReview', 'isLoading', 'isFetched', 'isFetching' ]),
		...mapGetters('campaigns', [ 'allConversions' ]),
		...mapGetters('monsterleads', [ 'allLeadsAllTime' ]),

		/**
		 * Validate if it should show the review bar with backend and frontend checks
		 *
		 * @returns {boolean} Show or not to show, that is the question
		 */
		shouldShowReviewBar () {
			return !this.dismissed &&
				this.showReview &&
				(50 < this.allConversions || 30 < this.allLeadsAllTime)
		},

		/**
		 * Validate if its loading any dismiss-review request
		 *
		 * @returns {boolean} Loading or not loading, that is the question
		 */
		isDismissing () {
			return this.isLoading('dismiss-review')
		},
	},
	methods : {
		...mapActions([ 'dismissReview' ]),

		/**
		 * Trigger show next step
		 *
		 * @param {boolean} positive Positive or negative next step
		 *
		 * @returns {void}
		 */
		showNextStep (positive = true) {
			this.showPositive = positive
			this.showNegative = !positive
		},

		/**
		 * Trigger all fetches necessary to this component
		 *
		 * @returns {void}
		 */
		fetchAllRequired () {
			// fetch leads from campaigns if not fetched or fetching already
			if (!this.isLoading('lead-campaigns') &&
				!this.isFetching('lead-campaigns') &&
				!this.isFetched('lead-campaigns')
			) {
				this.$store.dispatch('monsterleads/fetchLeadsCampaigns')
			}

			// fetch all campaigns if necessary - it controls if it should or not load them
			this.$store.dispatch('campaigns/fetchDashboard')
		},

		/**
		 * Instant dismiss the review bar and trigger the API request for background
		 *
		 * @returns {void}
		 */
		instantDismiss () {
			this.dismissed = true

			this.dismissReview(true)
		},
	},
}
</script>

<style lang="scss">
.omapi-review-bar {
	&.omapi-card__notitle.omapi-card__nofooter .omapi-card-content {
		padding: 24px 17px;
	}

	&__title {
		font-size: 21px;
		line-height: 1.4em;
		font-weight: 600;
	}

	&__buttons {
		margin-top: 20px;

		.omapi-button {
			height: 34px;
		}
	}

	&__step {
		margin-top: 20px;

		a + a {
			margin-right: 10px;
		}
	}
}
</style>
